import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';

export default function SpiceLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#dc2626";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Spice • Restaurant Menu",
    title: "Bold flavours. Fiery passion.",
    subtitle: "Authentic food, restaurant-quality meals, and spice-forward products delivered right to you.",
    primaryCta: "Order Now",
  });
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: T.backgroundColor || "#fff5f5", fontFamily: T.fontFamily || "Roboto, sans-serif" }}>
      <div className="py-2 text-center text-[11px] font-bold uppercase tracking-[0.22em] text-white" style={{ backgroundColor: primary }}>{p.storeInfo?.businessCategory || p.storeInfo?.businessName}</div>
      <nav className="sticky top-0 z-40 border-b border-red-200 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-red-200" />
          <div>
            <p className="text-sm font-bold text-red-900">
              <InlineEditableText p={p} field="businessName" value={p.storeInfo?.businessName}>
                {p.storeInfo?.businessName || "Your Store"}
              </InlineEditableText>
            </p>
            <p className="text-[10px] text-red-500 font-medium tracking-wide">{p.storeInfo?.businessCategory || text.storeInfo || "Store Info"}</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 hidden md:block ml-3" />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-xl border border-red-200 hover:bg-red-50" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full text-white flex items-center justify-center" style={{ backgroundColor: primary }}>{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="max-w-7xl mx-auto w-full px-4 pt-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_0.7fr] gap-5">
          <div className="rounded-3xl overflow-hidden shadow-[0_18px_55px_rgba(220,38,38,0.3)]">
            <HeroImage p={p} themeId={p.resolvedThemeId || T.themeId || "spice"} className="h-[340px] md:h-[400px]">
              <div className="absolute inset-0 bg-gradient-to-r from-red-950/85 via-red-900/45 to-transparent pointer-events-none" />
              <div className="absolute inset-0 px-8 flex flex-col justify-center pointer-events-none">
                <span className="inline-block text-[10px] uppercase tracking-[0.26em] font-bold px-3 py-1 rounded-full bg-red-500/25 text-red-200 mb-3 w-fit pointer-events-auto"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
                <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight max-w-lg pointer-events-auto"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
                <p className="mt-3 text-red-100/65 max-w-md text-sm pointer-events-auto"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
                <button onClick={() => p.setActiveTab("products")} className="mt-6 w-fit px-7 py-3.5 rounded-xl text-sm font-bold text-white shadow-lg pointer-events-auto" style={{ backgroundColor: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
              </div>
            </HeroImage>
          </div>
          <div className="rounded-3xl border border-red-200 bg-white p-5 shadow-sm flex flex-col gap-4">
            {[{l:text.menu || text.products || "Menu", v:p.filteredProducts?.length||0},{l:text.services || "Services", v:p.filteredServices?.length||0}].map(s => (
              <div key={s.l} className="rounded-2xl border border-red-100 bg-red-50 px-4 py-3">
                <p className="text-xs text-red-600 font-semibold">{s.l}</p>
                <p className="text-2xl font-extrabold text-red-900 mt-0.5">{s.v}</p>
              </div>
            ))}
            <div className="rounded-2xl border border-orange-100 bg-orange-50 px-4 py-3">
              <p className="text-xs text-orange-600 font-semibold">Delivery</p>
              <p className="text-xl font-extrabold text-orange-900 mt-0.5">Express</p>
            </div>
            <button onClick={() => p.setActiveTab("products")} className="mt-auto w-full py-3 rounded-xl text-sm font-bold text-white" style={{ backgroundColor: primary }}>{text.viewAll || "View all"}</button>
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto w-full px-4 mt-5">
        <div className="rounded-2xl border border-red-200 bg-white p-1.5 flex gap-1.5 overflow-x-auto">
          {[["products", getTabLabel(p, "products", "menu")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2 rounded-xl text-sm font-semibold whitespace-nowrap" style={p.activeTab===k ? { backgroundColor: primary, color:"#fff" } : { color:"#991b1b" }}>{l}</button>
          ))}
        </div>
      </section>
      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></section>
      <StoreFooter p={p} />
    </div>
  );
}